export default {
  button: 'components.views.reset-password-view.return-link.button'
}
